import { render, staticRenderFns } from "./BrandServiceCard.vue?vue&type=template&id=6873421a&scoped=true&"
import script from "./BrandServiceCard.vue?vue&type=script&lang=ts&"
export * from "./BrandServiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrandServiceCard.vue?vue&type=style&index=0&id=6873421a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6873421a",
  null
  
)

export default component.exports